import { render, staticRenderFns } from "./Wedding.vue?vue&type=template&id=6f1df5e4&"
import script from "./Wedding.vue?vue&type=script&lang=js&"
export * from "./Wedding.vue?vue&type=script&lang=js&"
import style0 from "./Wedding.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Wedding.vue"
export default component.exports